import { apiClient } from './client';
import {
  TagResponse, CreateTagRequest, UpdateTagRequest,
  BulkAddTagRequest, BulkRemoveTagRequest,
} from '../types';

export const getTags = () =>
  apiClient.get<TagResponse[]>('/api/tags').then(r => r.data);

export const createTag = (req: CreateTagRequest) =>
  apiClient.post<TagResponse>('/api/tags', req).then(r => r.data);

export const updateTag = (id: string, req: UpdateTagRequest) =>
  apiClient.put<TagResponse>(`/api/tags/${id}`, req).then(r => r.data);

export const deleteTag = (id: string) =>
  apiClient.delete(`/api/tags/${id}`).then(() => {});

export const bulkAddTag = (req: BulkAddTagRequest) =>
  apiClient.post<{ tag: TagResponse; affected: number }>('/api/tags/bulk-add', req).then(r => r.data);

export const bulkRemoveTag = (req: BulkRemoveTagRequest) =>
  apiClient.post<{ affected: number }>('/api/tags/bulk-remove', req).then(r => r.data);
